export const strokeDash2Icon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M1 9v2h2V9zm8 0v2h2V9zm4 2V9h2v2zM5 9v2h2V9zm12 2V9h2v2z"/></svg>`,
  name: 'stroke-dash-2',
};
